import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import OnEnterFigureTagEditing from './enterafterfiguretagediting';

export default class OnEnterFigureTag extends Plugin {
  static get requires() {
    return [ OnEnterFigureTagEditing ];
  }

  static get pluginName() {
    return 'OnEnterClick';
  }
}
